import { render, staticRenderFns } from "./StatusIconCell.vue?vue&type=template&id=485b6a95"
import script from "./StatusIconCell.vue?vue&type=script&lang=js"
export * from "./StatusIconCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports